import React from "react";

export default function Courseview() {
  return (
    <div>Kurs Görüntüleme Sayfası Çalışma Aşamasında Lütfen Bekleyin...</div>
  );
}
